import React from "react";
import { Box, Container, Typography, Alert } from "@mui/material";
import { ReactComponent as Rounded } from "../../../assets/icons/rounded.svg";
import { ReactComponent as triangle } from "../../../assets/icons/triangle.svg";
import { ReactComponent as circle } from "../../../assets/icons/circle.svg";
import { ReactComponent as cancel } from "../../../assets/icons/cancel.svg";
import {ReactComponent as filledtick} from "../../../assets/icons/filledtick.svg"
 
const rows = [
  {
    label: "開発",
    sharepoint: {
      status: "check",
      text: "必要な機能を柔軟に開発できる\n動きのある見やすい画面も作れる",
    },
    scratch: {
      status: "partial",
      text: "一部の機能は対応できない\n動きのある見やすい画面は作りにくい",
    },
    webapp: {
      status: "",
      text: "必要な機能を開発できる\n動きのある見やすい画面も作れる",
    },
  },
  {
    label: "パフォーマンス",
    sharepoint: { status: "check", text: "SharePoint内で動作" },
    scratch: { status: "", text: "ただしPCごとにインストールが必要" },
    webapp: { status: "", text: "URLを開くだけで利用可能" },
  },
  {
    label: "セキュリティ",
    sharepoint: {
      status: "check",
      text: "SharePoint標準のセキュリティを\nそのまま利用",
    },
    scratch: { status: "", text: "クラウド側の設定に依存" },
    webapp: { status: "", text: "クラウド側の設定に依存" },
  },
  {
    label: "コスト",
    sharepoint: {
      status: "check",
      text: "M365ライセンスのみ。アプリもデータも\nSharePoint内のため追加費用なし",
    },
    scratch: { status: "cross", text: "開発費とDB費用が発生" },
    webapp: { status: "cross", text: "開発費とクラウド運用費が発生" },
  },
  {
    label: "運用",
    sharepoint: { status: "check", text: "手間が少ない" },
    scratch: { status: "partial", text: "開発側のサポートが必要" },
    webapp: { status: "partial", text: "開発側のサポートが必要" },
  },
  {
    label: "メンテナンス",
    sharepoint: {
      status: "check",
      text: "ソースコードの管理のみ\nアプリもデータもSharePoint内で完結",
    },
    scratch: { status: "partial", text: "継続的な対応が必要" },
    webapp: { status: "partial", text: "継続的な対応が必要" },
  },
];
 
const StatusIcon = ({ status }) => {
  if (status === "check")
    return (
      <Box
        component={Rounded}
        sx={{ color: "#FF6000", width: 22, height: 22, flexShrink: 0 }}
      />
    );
  if (status === "cross")
    return (
      <Box
        component={cancel}
        // sx={{ color: "#FF6000", width: 22, height: 22, flexShrink: 0 }}
      />
    );
  if (status === "partial")
    return (
      // <ChangeHistoryIcon sx={{ color: "rgba(0,0,0,0.55)", fontSize: 18 }} />
      <Box
        component={triangle}
        // sx={{ color: "#FF6000", width: 22, height: 22, flexShrink: 0 }}
      />
    );
  return (
    <Box
        component={circle}
    />
  );
};
 
const Cell = ({ data, highlight }) => (
  <Box
    component="td"
    sx={{
      p: 2.5,
      verticalAlign: "top",
      backgroundColor: highlight ? "#FFF7F0" : "transparent",
      borderLeft: "1px solid #D1D6DB",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
      <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
        <StatusIcon status={data.status} />
      </Box>
      <Typography
        sx={{
          fontSize: "13px",
          fontWeight: highlight ? 700 : 400,
          lineHeight: 1.7,
          whiteSpace: "pre-line",
        }}
      >
        {data.text}
      </Typography>
    </Box>
  </Box>
);
 
const ComparisonTable = () => {
  return (
    <Box sx={{ backgroundColor: "#fff", py: { xs: 6, md: 8 } }}>
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Typography
          sx={{
            color: "#FF6000",
            fontWeight: 700,
            fontSize: "13px",
            letterSpacing: "1px",
            mb: 1,
          }}
        >
          COMPARISON
        </Typography>
 
        <Typography
          sx={{ fontWeight: 700, fontSize: { xs: "26px", md: "50px" }, mb: 1.5 }}
        >
          比較表
        </Typography>
 
        <Typography
          sx={{
            fontSize: "20px",
            color: "rgba(0,0,0,0.65)",
            mb: { xs: 4, md: 5 },
          }}
        >
          「SharePoint（SPFx）」「デスクトップアプリ＋クラウドDB」「ウェブアプリ」の3方式を、開発・コスト・運用の観点で比較しました。
        </Typography>
 
        <Box
          sx={{
            overflowX: "auto",
            borderRadius: "12px",
            border: "1px solid #D1D6DB",
          }}
        >
          <Box
            component="table"
            sx={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
              minWidth: 800,
            }}
          >
            <Box component="colgroup">
              <Box component="col" sx={{ width: "16%" }} />
              <Box component="col" sx={{ width: "28%" }} />
              <Box component="col" sx={{ width: "28%" }} />
              <Box component="col" sx={{ width: "28%" }} />
            </Box>
            <Box component="thead">
              <Box component="tr">
                <Box
                  component="th"
                  sx={{
                    textAlign: "left",
                    p: 2.5,
                    fontSize: "14px",
                    color: "rgba(0,0,0,0.6)",
                    backgroundColor: "#f5f5f6",
                  }}
                />
                <Box
                  component="th"
                  sx={{
                    p: 2.5,
                    backgroundColor: "#575E69",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: "15px",
                    textAlign: "left",
                    borderLeft: "1px solid #D1D6DB",
                  }}
                >
                  SharePoint（SPFx）
                </Box>
                <Box
                  component="th"
                  sx={{
                    p: 2.5,
                    fontWeight: 700,
                    fontSize: "15px",
                    textAlign: "left",
                    backgroundColor: "#fff",
                    borderLeft: "1px solid #D1D6DB",
                  }}
                >
                  デスクトップ＋クラウドDB
                </Box>
                <Box
                  component="th"
                  sx={{
                    p: 2.5,
                    fontWeight: 700,
                    fontSize: "15px",
                    textAlign: "left",
                   backgroundColor: "#fff",
                    borderLeft: "1px solid #D1D6DB",
                  }}
                >
                  ウェブアプリ
                </Box>
              </Box>
            </Box>
            <Box component="tbody">
              {rows.map((row) => (
                <Box
                  component="tr"
                  key={row.label}
                  sx={{
                    borderTop: "1px solid #D1D6DB",
                    // background: '#F4F5F6'
                  }}
                >
                  <Box
                    component="td"
                    sx={{
                      p: 2.5,
                      fontWeight: 700,
                      fontSize: "14px",
                      alignItems: 'center',
                      background: '#f5f5f6'
                    }}
                  >
                    {row.label}
                  </Box>
 
                  <Cell data={row.sharepoint} highlight />
                  <Cell data={row.scratch} />
                  <Cell data={row.webapp} />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
 
        <Alert
          icon={
            <Box
              component={filledtick}
              sx={{ color: "#FF6000", width: "50px", height: "50px" }}
            />
          }
          sx={{
            mt: 3,
            background: "initial",
            border: "1px solid #FF6000",
            borderRadius: "5px",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            color: "#FF6000",
            fontSize: "18px",
          }}
        >
          見やすい画面と必要な機能を確保しながら、サーバーの追加費用も個別ライセンス費もかからないのは、いまのMicrosoft 365を
          そのまま使うSharePoint（SPFx）方式です。
        </Alert>
      </Container>
    </Box>
  );
};
 
export default ComparisonTable;